import { highContrastMode } from "./highContrastChecker";
export const fill = highContrastMode ? 'white' : 'rgba(0, 0, 0, 0.54)';

export const fillBlue = highContrastMode ? 'white' : 'rgb(60, 65, 154)';

export const fillRed = highContrastMode ? 'white' : '#D32F2F';

export const fillBlueYellow = highContrastMode ? 'yellow' : 'rgb(60, 65, 154)';

export const fillOpacity = highContrastMode ? 1 : 0.3;

export const fillHover = highContrastMode ? 'white' : "#3C419A";

export const fillTooltipArrow = highContrastMode ? 'white' : '#2C2D3E';

